// Which authentication mode the SPA runs in. Resolved once at module load.
//
// - "dev"     : VITE_DEV_AUTH=true. Always-authenticated local identity sent via
//               the X-Dev-Email header (no real credential check).
// - "local"   : VITE_AUTH_MODE=local. Built-in email + password sign up / sign in
//               against the backend local credential provider; the API client
//               attaches the returned bearer token.
// - "cognito" : default. Cognito Hosted UI (Authorization Code + PKCE).
//
// VITE_DEV_AUTH=true takes precedence over VITE_AUTH_MODE.

export type AuthMode = 'dev' | 'local' | 'cognito';

function resolveMode(): AuthMode {
  if (import.meta.env.VITE_DEV_AUTH === 'true') return 'dev';
  if (import.meta.env.VITE_AUTH_MODE === 'local') return 'local';
  return 'cognito';
}

export const AUTH_MODE: AuthMode = resolveMode();
export const LOCAL_AUTH = AUTH_MODE === 'local';
